import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { positionDropdown } from '../../../../../common/dropdown'
import useDidUpdateEffect from '../../../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../../../common/html/element'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { debounce } from '../../../../../helpers/common'
import { Input } from '../../../../common/html/input'
import { InputSearchDropdown } from '../../../../common/html/input/InputSearchDropdown'
import { TYPE_DELETE } from '../../../../constant'
import { DropdownItem } from '../../../portfoliosOverview/headerPortfoliosOverview/Search'
import {
  changeTextSearchAddCompany,
  clearSearchCompany,
  getLoadingSavedPortfolio,
  selectDataSearchCompany,
  selectTextSearchAddCompany,
} from '../../../portfoliosOverview/store/slice/slice'
import { getSearchCompany } from '../../../portfoliosOverview/store/thunk'
import {
  changeListCompanyImport,
  clearStoreAddNewCompany,
  selectIdsTableAddCompany,
  selectLoadingImportCompany,
} from '../../store/slice'
import { ConfirmApply } from './ConfirmApply'
import { ConfirmClearAll } from './ConfirmClearAll'
import { GroupUploadFile } from './GroupUploadFile'
import { ListCompany } from './ListCompany'

export const PopupCreateCompany = ({ isShow, setShow }) => {
  const dispatch = useDispatch()

  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const dataSearchCompany = useSelector(selectDataSearchCompany)
  const ids = useSelector(selectIdsTableAddCompany)
  const isLoadingSearch = useSelector(getLoadingSavedPortfolio('searchCompany'))
  const text = useSelector(selectTextSearchAddCompany)
  const locale = useSelector((state) => state.i18n.locale)
  const isLoadingImport = useSelector(selectLoadingImportCompany)

  const dataSearchFormat = dataSearchCompany.filter(
    (item) => !ids.includes(item.organizationId),
  )

  const [isDisplay, setDisplay] = useState(true)
  const [isShowConfirmClearAll, setShowConfirmClearAll] = useState(false)
  const [isShowConfirmApply, setShowConfirmApply] = useState(false)
  const [inputValue, setInputValue] = useState(text)

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(changeTextSearchAddCompany(value))
      dispatch(
        getSearchCompany({
          term: value,
          page: 1,
          pageSize: 100,
          PortfolioId: id,
          includeType: TYPE_DELETE.NOT_IN,
        }),
      )
    }, 700),
    [],
  )

  const handleChoose = (value) => {
    dispatch(
      changeListCompanyImport({
        id: value?.organizationId,
        taxCode: value?.taxCode,
        companyName: value?.organizationName,
      }),
    )
  }

  const handleCancel = () => {
    if (!!ids.length) {
      setShowConfirmClearAll(true)
      setDisplay(false)
    } else {
      setShow(false)
    }
  }

  const clearFunction = () => {
    dispatch(clearStoreAddNewCompany())
    dispatch(clearSearchCompany())
  }

  const handleOnFocus = () => {
    if (!dataSearchCompany.length) {
      handleChangeText(inputValue)
    }
  }

  const renderElement = () => {
    return (
      <div style={{ paddingBottom: 8 }}>
        <Input
          containerStyle={{
            flex: 1,
            width: '100%',
            height: '28px',
          }}
          placeHolder="library.savePortfolio.SEARCH_COMPANIES"
          type="text"
          isSearch
          onChange={setInputValue}
          value={inputValue}
          handleOnFocus={handleOnFocus}
        />
      </div>
    )
  }

  const renderDropdown = ({ hideDropdown }) => {
    return (
      <div style={{ zIndex: 13 }}>
        {dataSearchFormat?.map((item) => (
          <DropdownItem
            key={item?.organizationId}
            item={item}
            hideDropdown={hideDropdown}
            handleChoose={handleChoose}
            noHiddenWhenClick
          />
        ))}
      </div>
    )
  }
  const renderNodata = () => {
    return (
      <Element style={{ fontStyle: 'italic', padding: 12 }}>
        <Translate value="library.main.NODATA_ADD_COMPANY" dangerousHTML />
      </Element>
    )
  }

  //UseEffect
  useDidUpdateEffect(() => {
    if (inputValue.length !== 1) {
      handleChangeText(inputValue, locale)
    }
  }, [inputValue, locale])

  useEffect(() => {
    return () => {
      clearFunction()
    }
  }, [])

  return (
    <div>
      {isShow && (
        <PopupAction
          appendStyle={{
            width: 608,
            padding: '20px',
            backgroundColor: '#F3F3F3',
            borderRadius: '4px',
            visibility: isDisplay ? 'visible' : 'hidden',
          }}
          isShow={isShow}
          title="library.detailsPortfolios.ADD_TO_PORT"
          handleClose={handleCancel}
          btnSubmit={{
            label: 'library.filterSetting.APPLY',
            event: () => {
              setShowConfirmApply(true)
              setDisplay(false)
            },
            disabled: !ids.length || isLoadingImport ? true : false,
            isI18n: true,
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            event: handleCancel,
            isI18n: true,
          }}
        >
          <Element elementName="p" style={{ paddingBottom: '13px' }}>
            <Translate value="library.detailsPortfolios.TEXT_POPUP_ADD_COMPANY" />
          </Element>
          <InputSearchDropdown
            style={{ width: '100%', padding: '1px 0' }}
            renderElement={renderElement}
            renderDropdown={renderDropdown}
            dropdownItemHeight={50}
            maxDropdownItem={10}
            data={dataSearchFormat}
            dropdownPosition={positionDropdown.BOTTOM_CENTER}
            isLoading={isLoadingSearch}
            renderNodata={renderNodata}
            isValidateTwoKey
            textInput={inputValue}
          />
          <GroupUploadFile />
          <ListCompany setDisplay={setDisplay} />
        </PopupAction>
      )}

      <ConfirmClearAll
        setShowPopupAddCompany={setDisplay}
        isShow={isShowConfirmClearAll}
        setShow={setShowConfirmClearAll}
        setNonePopup={setShow}
        isTurnOff={true}
        clearFunction={clearFunction}
      />
      {isShowConfirmApply && (
        <ConfirmApply
          isShow={isShowConfirmApply}
          setShow={setShowConfirmApply}
          count={ids.length}
          setShowPopupAddCompany={setDisplay}
          setNonePopup={setShow}
          ids={ids}
          clearFunction={clearFunction}
        />
      )}
    </div>
  )
}
